<template>
  <div class="container-fluid my-2">
    <b-row class="align-items-center">
      <b-col>
        <h1 class="page-title my-auto">Cyber Protection</h1>
      </b-col>
      <b-col
        v-if="$route.name !== 'Alert' && !isCollaborator"
        class="col-xl-2 col-3 my-auto text-right"
        style="cursor: pointer"
        @click="$router.push('/app/alert').catch(() => {})"
      >
        <div class="d-flex align-items-center justify-content-end">
          <span class="notification icon-orange-info" v-if="!isLoading">
            <span class="badge" v-if="numberNotifications > 0">{{
              this.numberNotifications
            }}</span>
          </span>
          <span v-else>...</span>
          <span class="ml-1 d-none d-sm-block ">Vos notifications</span>
        </div>
      </b-col>
      <b-col
        v-else-if="!isCollaborator"
        class="col-1 my-auto mr-2"
        style="cursor:pointer;"
      >
        <span
          @click="$router.push('/app/Dashboard').catch(() => {})"
          class="o-link fa fa-home fa-2x  mr-2"
        />
      </b-col>
    </b-row>
    <b-row style="overflow-x: auto;" v-if="$route.name !== 'Alert'">
      <b-col>
        <nav class="ob1-menu-page h-100">
          <ul class="nav o-nav-light">
            <li
              class="nav-item"
              v-if="!isCollaborator"
              v-bind:class="[$route.name === 'Dashboard' ? 'active' : '']"
            >
              <span
                class="nav-link cursor-pointer"
                @click="$router.push('/app/Dashboard').catch(() => {})"
                >Tableau de bord</span
              >
            </li>
            <li
              class="nav-item"
              v-if="!isCollaborator"
              v-bind:class="[$route.name === 'Quarantine' ? 'active' : '']"
            >
              <span
                class="nav-link cursor-pointer"
                @click="$router.push('/app/quarantine').catch(() => {})"
                >Quarantaine</span
              >
            </li>
            <li
              class="nav-item"
              v-bind:class="[$route.name === 'Installation' ? 'active' : '']"
            >
              <span
                class="nav-link cursor-pointer"
                @click="$router.push('/app/installation').catch(() => {})"
                >Installation</span
              >
            </li>
            <li
              class="nav-item"
              v-if="!isCollaborator"
              v-bind:class="[$route.name === 'Gestion' ? 'active' : '']"
            >
              <span
                class="nav-link cursor-pointer"
                @click="$router.push('/app/gestion').catch(() => {})"
                >Gestion</span
              >
            </li>
            <li
              class="nav-item"
              v-if="!isCollaborator"
              v-bind:class="[$route.name === 'Account' ? 'active' : '']"
            >
              <span
                class="nav-link cursor-pointer"
                @click="$router.push('/app/account').catch(() => {})"
                >Votre compte Cyber Protection</span
              >
            </li>
          </ul>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import logger from "@/utils/func/logger";

export default {
  name: "NavBar",
  data() {
    return {
      numberAlerts: 0,
      isLoading: false,
      paramRequest: {
        page: 1,
        perPage: 1,
        adminOhpEuid: this.$store.state.configuration.adminOhpEuid || "",
      },
    };
  },
  computed: {
    isCollaborator() {
      return localStorage.getItem("user.role") === "COLLABORATOR";
    },
    //@get total unread count from Vuex store (all 3 types)
    numberNotifications() {
      const alertsCount = this.$store.getters['notification/getTotalAlerts'] || 0;
      const securityCount = this.$store.getters['notification/getUnreadCount'] || 0;
      const productCommCount = this.$store.getters['notification/getUnreadProductCommunicationsCount'] || 0;
      return alertsCount + securityCount + productCommCount;
    },
  },
  mounted() {
    if (!this.isCollaborator) {
      this.countNotifications();
      //@setup real-time listeners for notification badge
      this.setupRealtimeListeners();
    }
  },
  beforeDestroy() {
    //@cleanup real-time listeners
    this.cleanupRealtimeListeners();
  },
  methods: {
    countNotifications() {
      this.isLoading = true;

      // Get alerts count
      const alertsPromise = this.$store.dispatch("notification/getAlerts", {
        page: 1,
        perPage: 1,
        agentId: this.paramRequest.agentId,
        adminOhpEuid: this.paramRequest.adminOhpEuid
      });

      // Get security notifications count
      const securityPromise = this.$store.dispatch("notification/getNotifications", { page: 1, perPage: 1 });
      
      // Get product communications count
      const productCommPromise = this.$store.dispatch("notification/getProductCommunications", { page: 1, perPage: 1 });

      Promise.all([alertsPromise, securityPromise, productCommPromise])
        .then(([alertsRes, securityRes, productCommRes]) => {
          logger.log("SUCCESS count Notifications", { alerts: alertsRes, security: securityRes, productComm: productCommRes });
          //@data is now stored in Vuex store, computed property will automatically update
          this.isLoading = false;
        })
        .catch((err) => {
          logger.error("Err call getNotifications", err);
          this.isLoading = false;
        });
    },

    setupRealtimeListeners() {
      const userId = localStorage.getItem('user.id');

      if (!userId) {
        return;
      }

      //@listen for security notifications
      this.$echo.private(`notifications.user.${userId}`)
        .listen('.security-notification.created', () => {
          //@refresh all counts
          this.countNotifications();
        });

      //@listen for product communications
      this.$echo.private(`notifications.user.${userId}`)
        .listen('.product-communication.created', () => {
          //@refresh all counts
          this.countNotifications();
        });

      //@listen for alerts
      this.$echo.private(`notifications.user.${userId}`)
        .listen('.alert.created', () => {
          //@refresh all counts
          this.countNotifications();
        });
    },

    cleanupRealtimeListeners() {
      const userId = localStorage.getItem('user.id');
      
      if (userId) {
        this.$echo.leave(`notifications.user.${userId}`);
      }
      
      //@cleanup tenant channel if exists
      const tenantId = localStorage.getItem('tenant.id');
      if (tenantId) {
        this.$echo.leave(`notifications.tenant.${tenantId}`);
      }
    },
  },
};
</script>

<style scoped>
.notification {
  color: black;
  text-decoration: none;
  padding: 15px 26px;
  position: relative;
  display: inline-block;
  border-radius: 2px;
}

.notification .badge {
  position: absolute;
  top: -2px;
  right: -2px;
  padding: 5px 10px;
  border-radius: 50%;
  background: red;
  color: white;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
